import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import * as ac from "./action-creators";
import { INITIAL_TEAMS_STATE } from "./constants";
import type { TeamsState } from "./types";

export const teamsReducer = createReducer<TeamsState, ActionType<typeof ac>>(INITIAL_TEAMS_STATE)
    .handleAction(ac.setTerritoryEnabled, (state, { payload }): TeamsState => ({ ...state, isEnabled: payload }))
    .handleAction(ac.setSelectedTeamId, (state, { payload }): TeamsState => ({ ...state, selectedTeamId: payload }))
    .handleAction(ac.resetTerritory, (): TeamsState => INITIAL_TEAMS_STATE);
